import { ResolveFn } from '@angular/router';
import { defer, firstValueFrom, map, of, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { HistoryContext } from '@markant-platform/shared/audit/configuration';
import { OrganizationService } from '@markant-platform/shared/organization/data-access';

export const OrganizationHistoryResolver: ResolveFn<HistoryContext> = async route => {
  const organizationService = inject(OrganizationService);

  const routeOrganizationId: string = route.paramMap.get('organizationId') as string;

  return await firstValueFrom(
    defer(() => {
      const organizationId$ = routeOrganizationId ? of(routeOrganizationId) : organizationService.getOrganizationId();

      return organizationId$.pipe(
        switchMap(organizationId => {
          return organizationService.getOrganizationDetailsById(organizationId);
        }),
        map(({ id, name }) => ({
          context: { organizationId: id as string },
          name: name,
          entryTypes: ['Organization', 'RegistrationRequest'],
        }))
      );
    })
  );
};
